export enum Orientation {
  Default = "DEFAULT",
  Vertical = "VERTICAL",
  Horizontal = "HORIZONTAL",
  Grid = "GRID",
}
